import React from "react"
import { FallbackMultiSelectContainer, Label } from "./Input.styled"

type Props = {
  label: string
  values: string[]
}

const FallbackMultiSelect = ({ label, values }: Props) => {
  return (
    <>
      <Label>{label}</Label>
      {values.length === 0 ? (
        "-"
      ) : (
        <FallbackMultiSelectContainer>
          {values.map((value) => (
            <span>{value}</span>
          ))}
        </FallbackMultiSelectContainer>
      )}
    </>
  )
}

export default FallbackMultiSelect
